import { render, staticRenderFns } from "./LaundryItemForm.vue?vue&type=template&id=045dbee8&scoped=true"
import script from "./LaundryItemForm.vue?vue&type=script&lang=js"
export * from "./LaundryItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045dbee8",
  null
  
)

export default component.exports